import axios, { AxiosError, AxiosResponse } from 'axios';
import { IAxiosConfig, IRequestOptions } from 'types/common';
import { SESSION_KEY } from 'hooks/queries/useMeQuery';

const request = <T>({
  options = { url: '/', method: 'get' },
  headers = {}
}: IRequestOptions): Promise<T> => {
  const lang = localStorage.getItem('lang') || 'pl';
  const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL + '/api/v1',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Accept-Language': lang,
      ACCEPT_LANGUAGE: lang,
      ...headers
    },
    responseType: 'json',
    withCredentials: true
  });

  const onSuccess = (response: AxiosResponse) => {
    return response.data;
  };

  // todo later
  const NO_REDIRECT_ON_401 = ['/login', '/account/me', '/pages'];

  const isAuthPage = () =>
    /^\/(login|register|password-reset)/.test(window.location.pathname);

  const onError = async (error: AxiosError) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem(SESSION_KEY);
    }
    const requestUrl = options?.url || '';
    const shouldRedirect =
      error?.response?.status === 401 &&
      !NO_REDIRECT_ON_401.includes(requestUrl) &&
      !isAuthPage();

    if (shouldRedirect) {
      localStorage.removeItem('currentUser');
      document.location.href = '/login';
    } else {
      const data = error?.response?.data as { error: string };
      throw new Error(data?.error || 'anErrorOccurred');
    }
    // tmp

    const originalRequest: IAxiosConfig = error.config as IAxiosConfig;

    // handle refresh token
    // if (error?.response?.status === 401 && !originalRequest.isRetryRequest) {
    //   originalRequest.isRetryRequest = true;
    //   const refreshToken = localStorage.getItem('auth-refresh-token');
    //
    //   await axios
    //     .put(process.env.REACT_APP_API_URL + '/auth/refresh', { refreshToken })
    //     .then((res) => {
    //       const { accessToken, refreshToken } = res.data;
    //
    //       localStorage.setItem('auth-token', accessToken);
    //       localStorage.setItem('auth-refresh-token', refreshToken);
    //
    //       originalRequest.headers &&
    //         (originalRequest.headers[
    //           'Authorization'
    //         ] = `Bearer ${accessToken.value}`);
    //
    //       return client.request(originalRequest);
    //     })
    //     .catch((reason) => {
    //       if (
    //         reason.response.status === 400 ||
    //         reason.response.status === 404
    //       ) {
    //         localStorage.removeItem('auth-token');
    //         localStorage.removeItem('auth-refresh-token');
    //       }
    //     });
    // }

    return Promise.reject(error.response || error.message);
  };

  return client(options).then(onSuccess).catch(onError);
};

export default request;
